<template lang="html">
  <div class="hardwareDesign">
    <div class="imagesCon">
      <img src="@/assets/image/hardware/1.jpg" alt="">
      <img src="@/assets/image/hardware/2.jpg" alt="">
      <img src="@/assets/image/hardware/3.jpg" alt="">
      <img src="@/assets/image/hardware/4.jpg" alt="">
      <img src="@/assets/image/hardware/5.jpg" alt="">
      <img src="@/assets/image/hardware/7.jpg" alt="">
    </div>

    <div class="footerMod">
      <div class="signUp">
        <div class="signUpPrice">
          <p class="originalCost">价格：<span>{{activityCon.cash_price}}</span></p>
        </div>
        <div class="signUpBtn" @click="signUp">立即报名</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {pagebase} from '@/utils/http.js';
  import utils from '@/utils/utils';
  import WxShare from '@/utils/wxshare';

  export default {
    data() {
      return {
        aid: this.$route.query.aid || '',
        activityCon: {},
        arrangeshow: false,
        pagebase: pagebase,
        listShow: false,
      }
    },

    mounted() {
      this.init();
    },

    methods: {
      init() {
        this.showStat();
        // 微信分享
        this.wxshare = new WxShare();
        this.getactivityCon();
      },

      showStat() {
        this.$http({
          url: '/api/showStat',
          method: 'post',
          params: {
            url: window.location.href,
          }
        })
      },

      getactivityCon() {
        this.$http({
          url: '/activity/Info',
          method: 'get',
          params: {
            activity_id: this.aid,
          },
        }).then(res => {
          if (res.code >= 0) {
            let data = res.data;
            this.activityCon = data;
            document.title = data.title;
            this.wxshare.share({
              title: data.title,
              desc: data.summary,
              link: window.location.href,
              imgUrl: data.cover,
            })
          }
        })
      },

      signUp() {
        var succeedUrl = encodeURIComponent(pagebase + '/#/paySucceed?activity_id=' + this.aid);
        if (utils.browserChecker.isWx()) {
          var channel = this.$route.query.channel || '';
          var open = encodeURIComponent(pagebase + '/#/payment?activity_id=' + this.aid + '&project=pcblayout' + '&channel=' + channel + '&succeed_url=' + succeedUrl);
          var url = 'http://edu.eda365.com/wechat_redirect.php?jump_url=' + open;
          window.location.href = url;
        } else {
          this.$router.push({
            path: '/payment',
            query: {
              activity_id: this.aid,
              channel: this.$route.query.channel || '',
              project: 'pcblayout',
              track_id: this.$route.query.track_id || '',
              succeed_url: succeedUrl,
            }
          })
        }
      },
    }
  }
</script>

<style lang="css" scoped>
  .hardwareDesign {
    box-sizing: border-box;
    background-color: #051a2d;
    padding-bottom: 6rem;
  }

  .imagesCon img {
    width: 100%;
  }

  .footerMod {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 8rem;
    background: linear-gradient(to bottom, rgba(13, 43, 72, 0.8), rgba(13, 43, 72, 1));
    z-index: 10;
  }
  
  .signUp {
    height: 3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(13, 43, 72, 0.01);
    box-sizing: border-box;
    padding: 0 3rem;
    margin-top: 1rem;
  }
  
  .signUpPrice {
    display: flex;
    height: 2rem;
    align-items: flex-end;
  }
  
  .originalCost {
    font-size: 1.6rem;
    color: #FFFFFF;
    margin-right: 1rem;
  }
  
  .originalCost span {
    color: #FFC851;
  }
  
  .currentPrice {
    font-size: 1rem;
    color: #CCCCCC;
  }
  
  .currentPrice span {
    color: #FFFFFF;
  }
  
  .signUpBtn {
    width: 10rem;
    height: 3rem;
    line-height: 3rem;
    border-radius: 3rem;
    background-color: #B68043;
    text-align: center;
    font-size: 1.6rem;
    color: #FFFFFF;
  }

  @media (min-width: 751px) {    
    .footerMod {
      width: 750px;
      left: 50%;
      margin-left: -375px;
    }
  }
</style>